import { useRef } from 'react';
import Footer from '@/components/Footer';
import Hero from '@/components/Referidos';
import getMetadata from '@/utils/getMetadata';
import { NextSeo } from 'next-seo';
import localeManager from '@/utils/localeManager';


const Contacto = ({ locale, footer, dict, initialPartner, campaign }) => {
  const root = useRef();

  return (
    <main ref={root} className="relative site-max mx-auto contacto">
      <NextSeo
        {...getMetadata({
          locale,
          title: 'Referidos',
          description: 'Integrá HOP como método de envío y ofrece envíos simples y rápidos.',
          pathname: '/referidos'
        })}
      />
      <Hero dict={dict} initialPartner={initialPartner} campaign={campaign} />
      <Footer footer={footer} locale={locale} />
    </main>
  );
};

export default Contacto;

export async function getServerSideProps({ req, query, locale: nextLocale, defaultLocale }) {
  const { locale, dict } = await localeManager.getLocaleResources(req, {}, nextLocale || defaultLocale);

  const initialPartner = query.utm_source
    ? decodeURIComponent(Array.isArray(query.utm_source) ? query.utm_source[0] : query.utm_source)
    : 'Sin referido';
  const campaign = query.utm_campaign
    ? decodeURIComponent(Array.isArray(query.utm_campaign) ? query.utm_campaign[0] : query.utm_campaign)
    : '';

  return {
      props: {
          locale,
          footer: dict.home.footer,
          dict,
          initialPartner,
          campaign
      }
  }
}
